import ModalSlot, { slot } from "../../components/ModalSlot"

const image = "https://assets.swoogo.com/uploads/full/3013942-651db3b01d654.png"

const links = [...slot(11, {space: 7.1, init: 10.7, height: 6.2}), {
    width: "28.4%",
    height: "4.8%",
    top: "89.7%",
    left: "34.8%"
}]

const slots = [
    {
        href: "",
        label: "Supplier Security WebApp Phase 2"
    },
    {
        href: "https://www.assure.securityforum.org",
        label: "ISF Assure"
    },
    {
        href: "https://www.isflive.org/s/article/The-Standard-of-Good-Practice-for-Information-Security-2022-consolidated-cross-reference",
        label: "SOGP 2022 consolidated cross reference"
    },
    {
        href: "https://www.isflive.org/s/article/The-Standard-of-Good-Practice-for-Information-Security-2022-cross-reference-to-the-Cloud-Security-Alliance-Cloud-Controls-Matrix-CSA-CCM-v4",
        label: "SOGP 2022 Cross Reference to the CSA CCM v4"
    },
    {
        href: "https://www.isflive.org/s/article/sogp-2022-cross-reference-to-ISO-IEC-27002-2022",
        label: "sogp-2022-cross-reference-to-ISO/IEC-27002:2022".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/The-ISF-Benchmark?topicId=0TO0J0000009AOFWA2",
        label: "Benchmark"
    },
    {
        href: "https://www.isflive.org/s/article/Standard-of-Good-Practice-for-Information-Security-2022-All-Files?topicId=0TO0J0000009AOIWA2",
        label: "Standard-of-Good-Practice-for-Information-Security-2022-All-Files".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/SOGP-WebApp?topicId=0TO0J0000009AOIWA2",
        label: "SOGP WebApp"
    },
    {
        href: "https://www.isflive.org/s/article/Measuring-Security",
        label: "Measuring-Security: Insight through data".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/Nurturing-Security-Governance-Becoming-effective-through-engagement",
        label: "Nurturing-Security-Governance:-Becoming-effective-through-engagement".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/article/Establishing-a-business-focused-security-assurance-programme-Report",
        label: "Establishing-a-business-focused-security-assurance-programme-Report".replaceAll("-", " ")
    },
    {
        href: "https://www.isflive.org/s/knowledge-library",
        label: "Visit the ISF Library"
    }
]

export default () => <ModalSlot img={image} links={links} slots={slots} />